import jwtDecode from 'jwt-decode';
import {useState} from 'react';
import AbstractController from '../../../../../vendors/services/abstractController';
import ContribuinteModel from '../../../PublicPage/model/contribuinte.model';
import ContribuinteService from '../../../../services/contribuinte.service';
import LoginService from '../../../../services/LoginService';
import {Mensagem} from '../../../../shared/mensagem/Mensagem';
import ToastService from '../../../../../vendors/services/toastService';

export default class AlterarCadastroController extends AbstractController {

    public data: any;
    public setData: any;
    public idData: any;
    public setIdData: any;
    public empresaList: any;
    public setEmpresaList: any;
    public tipoInteressadoList: any;
    public setTipoInteressadoList: any;
    public areaInteresseList: any;
    public setAreaInteresseList: any;
    public ufList: any;
    public setUfList: any;
    public municipioList: any;
    public setMunicipioList: any;
    public model: ContribuinteModel;
    private service: ContribuinteService;
    private loginService: LoginService;

    constructor() {
        super();

        this.service = new ContribuinteService();
        this.loginService = new LoginService();
        this.model = new ContribuinteModel();
        [this.data, this.setData] = useState({});
        [this.idData, this.setIdData] = useState({});
        [this.empresaList, this.setEmpresaList] = useState([]);
        [this.tipoInteressadoList, this.setTipoInteressadoList] = useState([]);
        [this.areaInteresseList, this.setAreaInteresseList] = useState([]);
        [this.ufList, this.setUfList] = useState([]);
        [this.municipioList, this.setMunicipioList] = useState([]);
    }

    init() {
        const dados = this.getUser();
        const idToken: any = jwtDecode(dados.dadosLoginUnico.govBrIdToken);
        this.setData(dados);
        this.setIdData(idToken);
        this.setEmpresaList(dados.dadosLoginUnico.empresaList);
        this.obterTipoInteressado(dados.dadosLoginUnico);
        this.obterAreaInteresse();
        this.obterDadosContribuinte();
        this.obterUf();
    }

    obterDadosContribuinte() {
        const user = this.getUser();
        this.start();
        this.service.findById(user.contribuinte.codContribuinte).then((res: any) => {
            this.stop();
            const result = res.result;
            this.model.setCdUf(result.cdUf);
            this.model.setCdMunicipio(result.cdMunicipio);
            this.obterMunicipio(result.cdUf);
            this.model.setCdTipoInteressado(result.cdTipoInteressado);
            this.model.setRlContribuinteAreaInteresse(result.rlContribuinteAreaInteresse);
            this.model.setCodContribuinte(result.codContribuinte);
            this.model.setStNotificarNovaAudiencia(result.stNotificarNovaAudiencia);
        });
    }

    public salvar() {
        if (!this.validaSalvar()) {
            ToastService.showError(Mensagem.PREENCHA_TODOS_CAMPOS);
            return;
        }
        if (!this.model.rlContribuinteAreaInteresse || this.model.rlContribuinteAreaInteresse.length <= 0) {
            ToastService.showError('Nenhuma área de interesse selecionada.');
            return;
        }
        this.start();
        const obj: any = this.model;
        obj.dsEmail = this.idData.email;
        obj.noRazaoSocial = this.idData.name;
        obj.nuInscricao = this.idData.sub;
        obj.tpContribuinte = this.empresaList.length > 0 ? 1 : 2;
        obj.tpInscricao = 1;
        obj.stAtivo = true;
        this.service.update(obj).then((res: any) => {
            this.stop();
            this.loginService.salvarDadosLoginUnico({dadosLoginUnico: this.data.dadosLoginUnico, contribuinte: res.result});
            this.history.push('/perfil/inicio');
            const that = this;
            setTimeout(() => {
                that.history.go(0);
            }, 500);
        }).catch(err => this.stop());
    }

    public validaSalvar() {
        let valid = this.validaCampo(this.model.cdUf, this.model.setUfValid);
        valid = this.validaCampo(this.model.cdMunicipio, this.model.setMunicipioValid) && valid;
        valid = this.validaCampo(this.model.cdTipoInteressado, this.model.setTipoInteressadoValid) && valid;
        return valid;
    }

    private obterTipoInteressado(dadosLoginUnico: any) {
        this.start();
        this.service.obterTipoInteressado(dadosLoginUnico.empresaList.length > 0 ? 1 : 2).then((res: any) => {
            this.stop();
            this.setTipoInteressadoList(res.result);
        }).catch(err => this.stop());
    }

    private obterAreaInteresse() {
        this.start();
        this.service.obterAreaInteresse().then((res: any) => {
            this.stop();
            this.setAreaInteresseList(res.result);
        }).catch(err => this.stop());
    }


    private obterUf() {
        this.start();
        this.service.obterUf().then((res: any) => {
            const lista = res.result;
            lista.forEach((f: any) => f.nomeUF = f.nomeUF + ' - ' + f.descricaoSigla)
            this.setUfList(lista);
            this.stop();
        }).catch(err => this.stop());
    }

    public obterMunicipio(cdUf: any) {
        if (!cdUf) {
            this.setMunicipioList([]);
            this.model.setCdUf('');
            this.model.setCdMunicipio('');
            return;
        }
        this.start();
        this.service.obterMunicipio(cdUf).then((res: any) => {
            this.stop();
            this.setMunicipioList(res.result);
        }).catch(err => this.stop());
    }

    public checkAreaInteresse(value: any) {
        const isPresent = this.model.rlContribuinteAreaInteresse.filter((f: any) => f.cdAreaInteresse === value).length > 0;
        if (isPresent) {
            this.model.setRlContribuinteAreaInteresse(
                [...this.model.rlContribuinteAreaInteresse.filter((f: any) => f.cdAreaInteresse !== value)]
            );
            return;
        }
        this.model.setRlContribuinteAreaInteresse([...this.model.rlContribuinteAreaInteresse, {cdAreaInteresse: value}]);
    }

    public isCheckAreaInteresse(value: any) {
        return this.model.rlContribuinteAreaInteresse.filter((f: any) => f.cdAreaInteresse === value).length > 0;
    }
}
